import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import Breakpoint from 'frontools/core/Breakpoint';
import Context from 'frontools/core/Context';
import { autobind } from 'frontools/decorators/Autobind';

declare var rangeSlider;

export default class Brightness extends AbstractDispatcher {

    private _light: HTMLElement;
    private _tl: TimelineMax = new TimelineMax({paused: true});
    private _lessButton: HTMLElement;
    private _moreButton: HTMLElement;
    private _glass: HTMLElement;
    private _arrows: HTMLElement;
    private _slider;
    private _dimmedAlpha: number = .9;
    private _undimmedAlpha: number = 0;


    constructor(
        private _el: HTMLElement,
        private _initialPos: number = 0        
    ) {
        super();

        this._light = document.querySelector('.js_brightness_light') as HTMLElement;
        this._lessButton = this._el.querySelector('.js_brightness_less') as HTMLElement;
        this._moreButton = this._el.querySelector('.js_brightness_more') as HTMLElement;
        this._arrows = this._el.querySelector('.slider_arrows') as HTMLElement;
        const slider = this._el.querySelector('[type="range"]');
        console.log(this._arrows);
        rangeSlider.create(slider, {
            polyfill: true,
            value: this._initialPos,
            onInit: () => {
                const handle = this._el.querySelector('.rangeSlider__handle');
                let glassFF = this._el.querySelector('.brightness_glass_ff') as HTMLElement;
                let glass = this._el.querySelector('.brightness_glass') as HTMLElement;
                if (Context.getInstance().isFirefox()) {
                    this._glass = glassFF;
                    this._el.removeChild(glass); 
                } else {
                    this._glass = glass;
                    this._el.removeChild(glassFF); 
                }
                
                handle.appendChild(this._glass);
                handle.appendChild(this._arrows);
                TweenMax.to(this._el, .5,  {alpha: 1, ease: Expo.easeOut});
            },
            onSlide: (position, value) => {
                if (Context.getInstance().isFirefox()) { 
                    this._tl.progress(position / 100).pause();
                } else { this._tl.progress(position / 115).pause(); }
            }
        });

        this._slider = slider;

        if (this._initialPos === 0) {
            TweenMax.to(this._light, 1, {delay: 1, alpha: this._dimmedAlpha, ease: Expo.easeOut, onComplete: () => {
                this._initSlider();
                this._seekTo(100, 2);
            }});
        } else {
            this._initSlider();
            this._seekTo(this._initialPos, 0);
        }

        document.querySelector('.brightness_glass').addEventListener('click', () => {
            if (this._arrows.classList.contains('hidden')) {
                return;
            } else {
                this._arrows.classList.add('hidden');
            }
        });
    }

    @autobind
    private _onControlClick(e: Event) {
        const increment = Number((e.currentTarget as HTMLElement).getAttribute('data-type'));
        const newValue = this._slider.rangeSlider.value + increment * 10;

        this._seekTo(newValue);
    }

    @autobind
    private _initSlider() {
        this._tl.add(TweenMax.fromTo(this._light, 1, { alpha: this._dimmedAlpha}, {alpha: this._undimmedAlpha, ease: Linear.easeNone }));
        // this._tl.add(TweenMax.to(this._moreButton, 1, { rotation: 180 }), 0);
        
        if (Context.getInstance().isFirefox()) {
            this._tl.add(TweenMax.fromTo(this._glass.querySelector('.bg'), 1, {opacity:0.3}, {opacity:1, ease: Linear.easeNone }), 0);
        } else {
            this._tl.add(TweenMax.from(this._glass.querySelector('.milk'), 1, {y: '100%'}), 0);
            this._tl.add(TweenMax.from(this._glass.querySelector('.milk_clip'), 1, {y: '-100%'}), 0);
        }

        this._moreButton.addEventListener('click', this._onControlClick);
        this._lessButton.addEventListener('click', this._onControlClick);
    }

    private _seekTo(value, speed: number = .5) {
        const obj = { pos: this._slider.rangeSlider.value };
        TweenMax.to(obj, speed, {pos: value, ease: Power1.easeOut, onUpdate: () => {
            this._slider.rangeSlider.update({ value: Math.ceil(obj.pos) }, true);
        }});
    }

}